import React, { useEffect, useContext } from 'react';
import styles from './style.css';
import { DEFAULT_LOADING_MESSAGE, FlowContext } from '../../core/flow-engine';
import Heading from '../../components/Typography/Heading/Heading';
import SubHeading from '../../components/Typography/SubHeading/SubHeading';
import PhoneNumber from '../../components/PhoneNumber/PhoneNumber';
import { MFBeaconButton } from '../../components/Beacon/BeaconComponents';
import NewAccountCard from './NewAccountCard';
import ExistingApplicationCard from './ExistingApplicationCard';
import { runDebounced } from '../../flows/shared/utils';
import Loader from '../../components/Loader/Loader';

export const HeadingSuffix = ({ authenticated, journeyExists, firstName }) => {
  const loggedInAndJourneyExists = authenticated && journeyExists;
  const headingSuffix = loggedInAndJourneyExists && `, ${firstName}`;
  if (!loggedInAndJourneyExists) return '';
  return headingSuffix;
};

const WelcomeScreen = () => {
  const subtitle =
    'Note: if you choose the same account type, it will erase the previous version you saved.';
  const { back, next, appState, queryString } = useContext(FlowContext);
  const {
    store: {
      loadedData: { profiles: journeyPayload },
      authenticated,
      app
    }
  } = appState;

  const journeyExists = journeyPayload && journeyPayload.length;
  const firstName = app?.customer?.name?.firstName;
  const { applicationID, loginrequired = false } = queryString;

  useEffect(() => {
    if (applicationID) {
      runDebounced(() =>
        next({ applicationID, consumerName: 'NASU', loginrequired })()
      );
    }
  }, []);

  if (applicationID) {
    return <Loader message={DEFAULT_LOADING_MESSAGE} />;
  }

  return (
    <div className="page-content" id="welcome-header">
      <Heading>
        Welcome back
        <HeadingSuffix
          authenticated={authenticated}
          journeyExists={journeyExists}
          firstName={firstName}
        />
      </Heading>

      {journeyExists ? (
        <div>
          <SubHeading className="subtitle">
            Let&apos;s finish setting up your accounts
          </SubHeading>
          <div className="cards">
            {journeyPayload.map(journey => {
              return (
                <div className="card-item" key={journey.applicationID}>
                  <ExistingApplicationCard journey={journey} />
                </div>
              );
            })}
            <div className="card-item new">
              <NewAccountCard subtitle={subtitle} />
            </div>
          </div>
        </div>
      ) : (
        <div className="form-group">
          <SubHeading className="subtitle">
            We don&apos;t have any unfinished applications on file for you.
          </SubHeading>
          <div className="cards">
            <NewAccountCard />
          </div>
        </div>
      )}

      <div className="note">
        <strong>Note:</strong> You can access unfinished applications for 90
        days. We save one unfinished application per account type.
      </div>

      <MFBeaconButton
        variant="secondary"
        size="normal"
        id="returnJourneyBack"
        onClick={back()}
        label="Back"
      />

      <PhoneNumber screen="default" />
      <style jsx>{styles}</style>
    </div>
  );
};

export default WelcomeScreen;
